import { configurationContainer } from "@/configurationContainer";

const withDatabaseIds = (databaseIds: number[]): string =>
    databaseIds.length > 0 ? `?setDb=${databaseIds.join("&setDb=")}` : "";

export const createProdaLinks = (path: string, databaseIds: number[] = []) => {
    return `${configurationContainer.PUBLIC_PRODA_URL}${path}${withDatabaseIds(databaseIds)}`;
};

export const createCoreUILinks = (path: string, databaseIds: number[] = []) => {
    return `${configurationContainer.PUBLIC_CORE_URL}${path}${withDatabaseIds(databaseIds)}`;
};
